export default "__VITE_ASSET__DmONfm_V__"